exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.filterBadge[data-v-82cd9044] {\n    z-index: 2;\n}\n\n", ""]);
